import BITBUCKET_BUILD_NUMBER from '../environments/BITBUCKET_BUILD_NUMBER.json'

const SENTRY_CONFIG = {
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: `ITS ${BITBUCKET_BUILD_NUMBER}`,
  environment: process.env.REACT_APP_SENTRY_ENV_NAME,
}

export default SENTRY_CONFIG
